import React, {createContext, useContext} from 'react';

import type {SaveStatus} from './data/use-sheet-editor';
import type {Catalog} from './model/catalog';
import type {Character} from './model/character';
import type {CharacterState, CharacterStatePatch} from './model/character-state';
import type {CharacterFeatures} from './model/feature-tree';

export type CharacterContextValue = {
	catalog: Catalog;
	state: CharacterState;
	features: CharacterFeatures;
	character: Character;
	/** id листа в базе; пока лист не создан — не задан */
	sheetId?: string;
	saveStatus: SaveStatus;
	update(patch: CharacterStatePatch): void;
	setChoice(key: string, values: string[]): void;
};

const CharacterContext = createContext<CharacterContextValue | null>(null);

export const CharacterProvider: React.FC<{value: CharacterContextValue; children: React.ReactNode}> = ({
	value,
	children,
}) => <CharacterContext.Provider value={value}>{children}</CharacterContext.Provider>;

export function useCharacter(): CharacterContextValue {
	const value = useContext(CharacterContext);
	if (!value) throw new Error('useCharacter вызван вне CharacterProvider');
	return value;
}
